import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import PageContext from '../../../config/page-settings.js';

import XenditTransactionList from './XenditTransactionList';

const XenditTransactions = (props) => {
  const pageContext = useContext(PageContext);

  useEffect(() => {
    pageContext.handleSetPageSidebar(true);
    pageContext.handleSetPageHeader(true);
    pageContext.handleSetPageContentFullWidth(false);
  }, []);

  return (
    <div>
      <h1 className="page-header">Xendit Transactions</h1>
      <XenditTransactionList />
    </div>
  );
};

export default withRouter(XenditTransactions);
